<template>
  <div>
    <span>
      <span v-for="(token, index) in tokenizedSentence" :key="index">
        <strong v-if="token.isBold">{{ token.text }}</strong>
        <span v-else>{{ token.text }}</span>
        <span v-if="index < tokenizedSentence.length - 1">&nbsp;</span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    sentence: {
      type: String,
      required: true,
    },
    actionableWords: {
      type: Array,
      required: true,
    },
  },

  computed: {
    tokenizedSentence() {
      if (!this.sentence) return [];

      const words = this.sentence.split(/\s+/);
      return words.map((word) => {
        const lower = word.toLowerCase();
        const isBold = !this.actionableWords.includes(lower);
        return { text: word, isBold };
      });
    },
  },
};
</script>
